
import { useEffect, useState } from "react";
import { BudgetTotalFooter } from "./BudgetTotalFooter";

// Utilitário para converter string monetária mascarada para número
function parseCurrencyToNumber(valor: string | number): number {
    if (typeof valor === 'number') return valor;
    if (!valor) return 0;
    let cleaned = valor.replace(/[^\d,]/g, '');
    const lastComma = cleaned.lastIndexOf(',');
    if (lastComma !== -1) {
        cleaned =
            cleaned.slice(0, lastComma).replace(/,/g, '') +
            '.' +
            cleaned.slice(lastComma + 1);
    }
    return Number(cleaned) || 0;
}

export function BudgetTotalFooterContainer({ methods }: { methods: any }) {
    const [aliquota, setAliquota] = useState(0);
    const steps = methods.watch("steps") || [];
    const percentageExtraCost = parseCurrencyToNumber(methods.watch("percentageExtraCost")) || 0;
    const isProfitMargin = methods.watch("isProfitMargin");
    const idProfitMargin = methods.watch("idProfitMargin");
    const profitMarginConfigs = methods.getValues && methods.getValues("profitMarginConfigs") ? methods.getValues("profitMarginConfigs") : [];
    const isDiscount = methods.watch("isDiscount");
    const discountType = methods.watch("discountType");
    const discountValueRaw = methods.watch("discountValue");
    const discountValue = parseCurrencyToNumber(discountValueRaw) || 0;
    
    // Soma todos os totais das etapas
    function calculateStepTotal(step: any) {
        if (!step || !step.itens) return 0;
        return step.itens.reduce((acc: number, item: any) => {
            const isLabor = item.isLabor;
            const wageRaw = isLabor ? (item.idLaborBudget?.wage ?? item.unitValue) : item.unitValue;
            const wage = parseCurrencyToNumber(wageRaw);
            const quantity = Number(item.quantity) || 0;
            return acc + (wage * quantity);
        }, 0);
    }
    const subtotal = steps.reduce((acc: number, step: any) => acc + calculateStepTotal(step), 0);
    // Aplica desconto
    let subtotalWithDiscount = subtotal;
    if (isDiscount && discountValue > 0) {
        if (discountType === "percentage") {
            subtotalWithDiscount = subtotal - (subtotal * (discountValue / 100));
        } else {
            subtotalWithDiscount = subtotal - discountValue;
        }
        if (subtotalWithDiscount < 0) subtotalWithDiscount = 0;
    }

    // Busca a alíquota do localStorage
    useEffect(() => {
        const ali = localStorage.getItem("alicota");
        setAliquota(ali ? Number(ali) : 0);
    }, []);

    // Busca o valor percentual da margem de lucro
    let percentageProfitMargin = 0;
    if (isProfitMargin && idProfitMargin) {
        const fullMarginConfig = localStorage.getItem("profitMarginBudgetConfigs");
        const marginConfigs = fullMarginConfig ? JSON.parse(fullMarginConfig) : [];
        const margin = marginConfigs.find((item: any) => item.id === idProfitMargin);

        if (margin) {
            percentageProfitMargin = Number(margin.value) || 0;
        }
    }

    // Cálculo total
    // Primeiro soma custo extra ao subtotal
    const extraCostValue = subtotalWithDiscount * (percentageExtraCost / 100);
    const subtotalComExtra = subtotalWithDiscount + extraCostValue;
    const aliquotaValue = subtotalComExtra * (aliquota / 100);
    const profitMarginValue = subtotalComExtra * (percentageProfitMargin / 100);
    const total = subtotalComExtra + aliquotaValue + profitMarginValue;

    return <BudgetTotalFooter subtotal={subtotalComExtra} aliquota={aliquota} profitMargin={percentageProfitMargin} total={total} />;
}
